module.exports = __webpack_public_path__ + "img/e2819a4.png";